var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-3xl px-4 xl:px-0 mx-auto my-12 lg:my-24"},[_c('BaseRichText',{staticClass:"rich-text-block",attrs:{"content":_vm.block.body}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }